//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState } from 'vuex'
import WebIM from '~/utils/WebIm'
export default {
  props: {
    msgList: { // 消息列表
      type: Object,
      default: () => {}
    },
    liveDetail: { // 直播详情
      type: Object,
      default: () => {}
    },
    liveConfig: { // 切流数据
      type: Object,
      default: () => {}
    },
    liveAudience: { // 在线观众
      type: [Number, String],
      default: 0
    },
    liveChatList: { // 历史消息
      type: Object,
      default: () => {}
    },
    forbidden: { // 历史消息
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      msg_text: '',
      msgLists: this.msgList,
      IMHeight: 0,
      isUserScrolling: false, // 用户是否手动滚动
      scrollThreshold: 50 // 距离底部多少像素时认为接近底部
    }
  },
  computed: {
    ...mapState({
      contentcookie: 'contentcookie'
    }),
    isZh () {
      const code = this.$store.state.LanguageCode
      if (code == 'zh-cn' || code == 'zh-tw' || code == 'zh-hk' || code == 'zh') {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    // 监听输入的交易商名称的变化
    // '$store.state.msgList.chatroom': {
    //   handler (newV) {
    //     this.$nextTick(() => {
    //       this.html_scroll()
    //     })
    //   },
    //   deep: true
    // }
    forbidden (newV) {
      if (newV) {
        this.msg_text = ''
        this.$emit('forbiddenclone')
        this.$nextTick(() => {
          this.html_scroll()
        })
      }
    }
  },
  created () {

  },
  beforeDestroy () {
    // 清理滚动事件监听器
    this.removeScrollListener()
  },
  mounted () {
    this.$nextTick(() => {
      this.IMHeight = document.querySelector('.live-IM').clientHeight
      // 添加滚动事件监听器
      this.addScrollListener()
    })
  },
  methods: {
    ...mapActions([
      'onSendText'
    ]),
    login () { // 点击登录
      if (this.contentcookie) return (this.reportpop = true)
      this.$store.commit('loginClose', true)
    },
    html_scroll (forceScroll = false) { // IM页面滑动到底部
      this.$nextTick(() => {
        const scrollContainer = document.querySelector('.IM-news')
        if (!scrollContainer) return

        // 如果用户正在手动滚动查看历史消息，且不是强制滚动，则不自动滚动到底部
        if (this.isUserScrolling && !forceScroll) {
          return
        }
        scrollContainer.scrollTo({
          top: scrollContainer.scrollHeight,
          behavior: 'smooth'
        })
      })
      // document.querySelector('.IM-news').scrollTo({ top: document.querySelector('.news-ul').clientHeight, behavior: 'smooth' })
    },
    onSendTextMsg () { // 消息发送
      if (this.msg_text == '' || this.msg_text == '\n') {
        // this.message = "";
        this.msg_text = ''
        return
      }
      this.$emit('mText', this.msg_text)
      const id = WebIM.conn.getUniqueId() // 生成本地消息id
      const msg = new WebIM.message('txt', id) // 创建文本消息消息
      const time = +new Date()
      const that = this
      const option = {
        to: that.liveDetail.chatroomid, // 接收消息对象（聊天室id）
        msg: that.msg_text, // 消息内容
        chatType: 'chatroom', // 群聊类型设置为聊天室
        time,
        // userId: this.$store.state.user.userId,
        // from: this.$store.state.user.userId,
        success: (e) => {
          console.log('发送消息成功，send private text Success', e)
          this.matomofn('Live_Text_Sent', {})
          const options = {
            chatType: 'chatroom',
            chatId: that.liveDetail.chatroomid,
            msg: that.msg_text,
            bySelf: true,
            time: +new Date(),
            mid: id,
            status: 'sending',
            nick: that.$store.state.user.nick
          }
          // this.updateMsgList(options) // 服务端消息成功后消息渲染
          that.$store.commit('updateMsgList', options)
          that.msg_text = ''
          that.$nextTick(() => {
            that.html_scroll(true) // 用户自己发送的消息，强制滚动到底部
          })
        }, // 对成功的相关定义，sdk会将消息id登记到日志进行备份处理
        fail: (e) => {
          console.log('文字发送失败' + JSON.stringify(e))
          const options = {
            chatType: 'chatroom',
            chatId: that.liveDetail.chatroomid,
            msg: that.msg_text,
            bySelf: true,
            time: +new Date(),
            mid: id,
            status: 'sending',
            nick: that.$store.state.user.nick
          }
          // that.updateMsgList(options) // 服务端消息成功后消息渲染
          that.$store.commit('updateMsgList', options)
          that.msg_text = ''
          that.$nextTick(() => {
            that.html_scroll(true) // 用户自己发送的消息，强制滚动到底部
          })
          // 失败原因:
          // e.type === '603' 被拉黑
          // e.type === '605' 群组不存在
          // e.type === '602' 不在群组或聊天室中
          // e.type === '504' 撤回消息时超出撤回时间
          // e.type === '505' 未开通消息撤回
          // e.type === '506' 没有在群组或聊天室白名单
          // e.type === '501' 消息包含敏感词
          // e.type === '502' 被设置的自定义拦截捕获
          // e.type === '503' 未知错误
        } // 对失败的相关定义，sdk会将消息id登记到日志进行备份处理
      }
      // this.msg_text = '' // 清空消息
      msg.set(option)
      WebIM.conn.send(msg.body)
    },
    addScrollListener () { // 添加滚动事件监听器
      const scrollContainer = document.querySelector('.IM-news')
      if (!scrollContainer) return

      scrollContainer.addEventListener('scroll', this.handleScroll)
    },
    handleScroll (event) { // 处理滚动事件
      const scrollContainer = event.target
      const { scrollTop, scrollHeight, clientHeight } = scrollContainer
      // 计算距离底部的距离
      const distanceFromBottom = scrollHeight - scrollTop - clientHeight
      // 如果距离底部小于阈值，认为用户接近底部，恢复自动滚动
      if (distanceFromBottom <= this.scrollThreshold) {
        this.isUserScrolling = false
      } else {
        // 如果距离底部较远，认为用户在查看历史消息
        this.isUserScrolling = true
      }
    },
    removeScrollListener () { // 移除滚动事件监听器
      const scrollContainer = document.querySelector('.IM-news')
      if (!scrollContainer) return

      scrollContainer.removeEventListener('scroll', this.handleScroll)
    }

  }
}
